import React, { useState } from "react";
import { Grid, Paper, Stack, Tab, Tabs, Typography } from "@mui/material";
import { ContentContainer } from "../Container/PageContentContainer";
import { navigationExtensionEmotionStyle } from "./navigationExtensionAllDataStyle";
import { HashLink as Link } from "react-router-hash-link";
import CaseAdditionalClientsTooltipIcon from "../Case/CaseAdditionalClientsTooltipIcon/CaseAdditionalClientsTooltipIcon";
import { hasGeneratableFilesAndAttachments } from "../../services/generatableFilesService";
import { ProductUnion } from "../../types/ProductUnion";

const NavigationExtensionCaseFileGenerate = ({ product }: { product: ProductUnion }) => {
  const [topOffset, setTopOffset] = useState(69);

  if (!product) {
    return null;
  }

  return (
    <Paper
      square
      ref={(el) => {
        if (el) {
          setTopOffset(el.getBoundingClientRect().top);
        }
      }}
      sx={navigationExtensionEmotionStyle.tabs({ top: topOffset })}
    >
      <ContentContainer size={"large"}>
        <Grid container>
          <Grid
            size={{
              xs: 12,
              lg: 4
            }}>
            <Stack
              sx={{
                justifyContent: "center",
                marginLeft: "2rem"
              }}>
              <Stack direction={"row"} spacing={1}>
                <Typography>
                  <strong>{product.backofficeCase?.label}</strong>{" "}
                  {!!product.opposingParty && <>./. {product.opposingParty}</>}
                </Typography>
                <CaseAdditionalClientsTooltipIcon product={product} fontSize={"small"} />
              </Stack>
              <Typography>Unser Zeichen: {product.reference}</Typography>
            </Stack>
          </Grid>
          <Grid
            size={{
              xs: 12,
              lg: 8
            }}>
            <Tabs variant={"fullWidth"} scrollButtons="auto" value={false} centered>
              <Tab component={Link} to={"#contractFiles"} label={"Fertiger Schriftsatz"} />
              {hasGeneratableFilesAndAttachments(product) && (
                <Tab component={Link} to={"#contractFilesAttachment"} label={"Schriftsatz und Anlagen"} />
              )}
              <Tab component={Link} to={"#casePdfGenerator"} label={"Schriftsatz erstellen"} />
            </Tabs>
          </Grid>
        </Grid>
      </ContentContainer>
    </Paper>
  );
};

export default NavigationExtensionCaseFileGenerate;
